import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { LookupService } from 'src/app/Services/LookupService';
import { IFormSurrogateParentAppointment } from "../../../../Models/Forms/IFormSurrogateParentAppointment";
import { FormSurrogateParentAppointmentService } from "../../../../Services/FormSurrogateParentAppointmentService";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';


@Component({
  selector: 'SurrogateParentAppointment',
  templateUrl: './SurrogateParentAppointment.component.html',
  styleUrls: ['./SurrogateParentAppointment.component.css']

})


export class FormSurrogateParentAppointmentComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  fromTime: Date;
  toTime: Date;
  _lookupService: LookupService;
  formSurrogateParentDB: any = [];
  reportParamArray: IReportParameter[];
  //public showSpinner: boolean = false;

  firstParagraph: string = '   (date), the following person has been appointed to serve as the surrogate parent for the above named student.';

  surrogateNameLabel: string = `Surrogate's Name:`;
  relationLabel: string = 'Relationship* to Student (If Applicable):';
  relationHelpTextLabel: string = '(e.g.Aunt, Uncle, Grandmother)';
  relationNoteLabel: string = `*Note: If the surrogate parent is not a relative caretaker, foster parent or court-appointed special advocate, each school must document in the Student's Log that efforts were first taken to identity the existence of a relative caretaker, foster parent or court - appointed special advocate and that this person was not willing and / or able to serve as the student's surrogate parent. [Ref: CA Gov't Code Section 7579.5(b)]`;

  surrogateReasonHeading: string = 'Reason Why a Surrogate Was Appointed';
  reasonInstructionLabel: string = '(Please Check the Applicable Box):';
  surrogateReason1A: string = '(A) The Child is adjudicated a dependent or ward of the court pursuant to Section 300, 601, or 602 of the Welfare and Institutions Code upon referral of the child to the local educational agency for special education and related services, or if the child already has a valid individualized education program,';
  surrogateReason1B: string = '(B) the court specifically had limited the right of the parent or guardian to make educational decisions for the child, and';
  surrogateReason1C: string = '(C) the child has no responsible adult to represent him or her pursuant to Section 361 or 726 of the Welfare and Institutions Code or Section 56055 of the Education Code.';
  surrogateReason2: string = 'No parent for the child can be identified.';
  surrogateReason3: string = 'LACOE, after reasonable efforts, cannot discover the location of a parent.';
  surrogateReason3Note: string = 'Note: If the 3rd box is checked above, school site staff must document its efforts to discover the location of the parent prior to the appointment of a surrogate parent.';


  meetingHeadingText: string = 'Surrogate Parent Meeting with Student';
  meetingRefSectionText: string = `[Ref: CA Gov't Code Section 7579.5(d)]`;
  studentSignLabel: string = '';
  surrogateSignLabel: string = '';
  studentNameLabel: string = '';

  constructor(
    private globals: Globals, reportService: ReportService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService,
    private _formSurrogateParentAppointmentService: FormSurrogateParentAppointmentService) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
  }


  ngOnInit(): void {
    this.LoadFormSurrogateParentAppointmentDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
  }

  LoadFormSurrogateParentAppointmentDetails(): void {
    this._formSurrogateParentAppointmentService.getFormSurrogateParentAppointment(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormSurrogateParentAppointment) => {
        this.formSurrogateParentDB = res;
        this.formSurrogateParentDB.effectiveDate = this.formSurrogateParentDB.effectiveDate == null ? null : new Date(this.formSurrogateParentDB.effectiveDate);
        this.formSurrogateParentDB.meetingDate = this.formSurrogateParentDB.meetingDate == null ? null : new Date(this.formSurrogateParentDB.meetingDate);

        let curDate = new Date(Date());
        if (this.formSurrogateParentDB.meetingFromTime != null) {
          let timeOnly = this.formSurrogateParentDB.meetingFromTime.value.hours + ":" + this.formSurrogateParentDB.meetingFromTime.value.minutes
          this.fromTime = new Date(curDate.getFullYear() + " " + timeOnly);
        }
        else {
          this.fromTime = null;
        }

        if (this.formSurrogateParentDB.meetingToTime != null) {
          let timeOnly = this.formSurrogateParentDB.meetingToTime.value.hours + ":" + this.formSurrogateParentDB.meetingToTime.value.minutes
          this.toTime = new Date(curDate.getFullYear() + " " + timeOnly);
        }
        else {
          this.toTime = null;
        }

      },
        err => console.error(err)
      );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the formPresentLevelsDB
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    if (this.fromTime != null) {
      this.formSurrogateParentDB.meetingFromTime = this.fromTime.getHours() + ":" + this.fromTime.getMinutes();
    }
    if (this.toTime != null) {
      this.formSurrogateParentDB.meetingToTime = this.toTime.getHours() + ":" + this.toTime.getMinutes();
    }

    //update values
    this._formSurrogateParentAppointmentService.insertUpdateFormSurrogateParentAppointment(this.formSurrogateParentDB)
      .subscribe((res: IFormSurrogateParentAppointment) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false;
        this.validateForm();
        this.LoadFormSurrogateParentAppointmentDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )

  }

  validateForm() {
    this._formSurrogateParentAppointmentService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }


  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormSurrogateParentAppointmentDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.formSurrogateParentDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False'  },
      { parameterName: 'FormInstanceID', parameterValue: this.formSurrogateParentDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'PlanAddendumID', parameterValue: '' },
      { parameterName: 'IEPID', parameterValue: this.formSurrogateParentDB.iepId.toString() }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formSurrogateParentDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formSurrogateParentDB.rdlFileNameSpanish, this.reportParamArray);
  }

}


